<template>
    <svg
        alt="TikTok"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M16.73 7.857a3.73 3.73 0 0 1-1.685-3.107h-2.67v10.695a2.253 2.253 0 0 1-2.247 2.16c-.374 0-.724-.1-1.036-.263a2.242 2.242 0 0 1-1.198-1.984 2.253 2.253 0 0 1 2.246-2.247c.225 0 .45.038.662.1v-2.72a5.696 5.696 0 0 0-.662-.05 4.913 4.913 0 0 0-4.904 4.904c0 1.66.836 3.133 2.096 4.019a4.913 4.913 0 0 0 7.725-4.019V9.93a6.378 6.378 0 0 0 3.707 1.198v-2.67a3.734 3.734 0 0 1-2.022-.6h-.012Z" fill="currentColor"/>
    </svg>
</template>
